<div class="materialTableHeader">
  <ng-content></ng-content>
</div>
